import axios from 'axios'
import axiosRetry from 'axios-retry'
import * as types from '../constants/actionTypes'
import constants from '../constants/constants'
import { IMPRESSIONS } from '../constants'

export const saveImpression = (impression) => (dispatch) => {
  dispatch({
    type: types.CREATE_IMPRESSION,
    data: impression
  })
}

export const flushAndSerializeImpressions =
  () => async (dispatch, getState) => {
    const { localStorage } = window
    const reduxImpressions = getState().impressions.impressions

    dispatch({
      type: types.CLEAR_IMPRESSIONS
    })

    const storedImpressions = localStorage.getItem('impressions')

    let parsedImpressions = []
    let impressionsToSave = []
    try {
      parsedImpressions = JSON.parse(storedImpressions) ?? []
    } catch {
      parsedImpressions = []
    } finally {
      impressionsToSave = [...parsedImpressions, ...reduxImpressions]
    }

    localStorage.setItem('impressions', JSON.stringify(impressionsToSave))

    if (impressionsToSave.length >= IMPRESSIONS.postBatchSize) {
      try {
        axiosRetry(axios, { retries: 3 })
        await axios.post(constants.api.v2.impressions, impressionsToSave, {
          headers: {
            Authorization: `bearer ${constants.keys.LOGGED_OUT_ACCESS_TOKEN}`
          }
        })
        impressionsToSave = []
      } catch {
        impressionsToSave = []
      } finally {
        localStorage.setItem('impressions', JSON.stringify(impressionsToSave))
      }
    }
  }

export const saveScreenImpression =
  (screenImpressionInfo) => (dispatch, getState) => {
    const reduxImpressions = getState().impressions.impressions

    if (reduxImpressions.length >= IMPRESSIONS.reduxBufferSize) {
      dispatch(flushAndSerializeImpressions())
    }

    dispatch(
      saveImpression({
        recordedAt: new Date().toISOString(),
        platform: 'web',
        ...screenImpressionInfo
      })
    )
  }
